import { createStyleIntent } from './createStyleIntent';
import { makeBatchedStyles } from './util';
import { serializeKey } from './serialize';
function serializeResetKey(styles, selector, media) {
    return serializeKey(JSON.stringify(styles), media + selector);
}
export const createResetStyles = createStyleIntent('reset', serializeResetKey, (styles, selector, media)=>()=>{
        let reset = styles;
        reset = {
            [selector || '&']: reset
        };
        if (media) {
            reset = {
                [media]: reset
            };
        }
        return makeBatchedStyles(reset);
    });

//# sourceMappingURL=createResetStyles.js.map